import React from "react";


import "./index.scss";


type CardDecorationByOrderComponentProps = {
    orderValue?: string | number;
}


export const CardDecorationByOrderComponent:React.FC<CardDecorationByOrderComponentProps> = ({
    orderValue
}) => {


    if (!orderValue) {
        return null;
    }


    return (
         <span className={'card-component__decoration-data__decoration-element card-component__decoration-data__decoration-element--order-nr'}>
             {orderValue}
         </span>
    );

};


export default CardDecorationByOrderComponent;
